module.exports = __webpack_public_path__ + "img/capsule-red.14b8ad0a.svg";